import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getMarcasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`mar_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/marcas", queryString);
};

export const getMarcaById = async (id) => {
    const res = await getData(`/marcas/${id}`)
    return res
}

export const getXMarca = async (searchTerm) => {
    return await getData("/marcas", `?mar_descripcion=${searchTerm}`);
};

export const postMarca = async (body) => {
    const res = await postData('/marcas', body)
    return res
}

export const patchMarca = async (id, body) => {
    const res = await patchData(`/marcas/${id}`, body)
    return res
}

export const deleteMarca = async (id) => {
    const res = await deleteData(`/marcas/${id}`)
    return res
}